import axios from 'axios'
import {config} from '@/api/config.js'
import {getSignHeader} from '@/utils/getSignHeader.js'

export const wechatCourseService = axios.create({
  baseURL: config.launcherService,
  timeout: 30000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  ret = ret.slice(0, -1)
  return ret
}]

export const getCourses = async (params) =>{
  let headers = getSignHeader(params)

  const {data} = await wechatCourseService.get(`/rjhy-edu/api/1/education/wechat/course/teacher/list`, {
    params, headers
  })
  if(data.code === 1) {
    return data.data
  } else {
    return null
  }
}

export const getGoodsNo = async (params) =>{
  let headers = getSignHeader(params)
  const {data} = await wechatCourseService.get(`/rjhy-edu/api/1/education/wechat/goods/list`, {
    params, headers
  })
  if(data.code === 1) {
    return data.data
  } else {
    return null
  }
}
